import styled from "@emotion/styled"

const HeroScrollCaseDemoMobileContainer = styled.div`
  width: fit-content;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-inline: auto;

  ${(props) => (props.isDoubleMobile ? "transform: translateX(-37%);" : "")},
`

export default HeroScrollCaseDemoMobileContainer
